<template>
  <div>
    <div class="wrapper">
      <div>
        <div class="empty-chat" v-if="!replies || replies.length === 0">
          <i class="fas fa-comments empty-chat__icon"></i>
          <p class="empty-chat__text">It's empty here</p>
          <p class="empty-chat__sub">Start a discussion!</p>
        </div>
        <b-list-group
          v-for="item in replies"
          :key="item.id"
          id="members_sharing"
          class="text-left mb-2">

          <b-list-group-item style="padding: 0px; border: 0px;">
            <div v-if="item.user_id === $store.state.profile.id && item.main_text != null" class="chat-container darker">
              <div class="chat-header">
                <img v-if="item.profile_image != null" :src="item.profile_image" alt="Avatar">
                <img v-else src="https://media.iamconnected.com/profile_images/default.png" alt="Avatar">
                <div class="chat-user-info">
                  <h5 class="user">{{item.first_name}} {{item.last_name}}</h5>
                  <span class="time">{{item.access.date}} {{item.access.time}}</span>
                </div>
                <div class="chat-actions">
                  <button @click="chatThreadModal(item)" title="Thread" class="btn thread threadBtn">
                    <b-badge v-if="item.replies > 0" class="threadBadge" variant="danger"> {{ item.replies }} </b-badge>
                    <i class="fas fa-solid fa-comment-dots fa-lg"></i>
                  </button>
                  <button @click="replyDelete(item, false)" class="btn delete"><i class="fas fa-trash-alt fa-lg"></i></button>
                </div>
              </div>
              <p v-html="item.main_text" class="message"></p>
              <message-reactions :message="item" :activeChallengeId="activeChallengeId" @react="onReact" />
            </div>
            <div v-if="item.user_id !== $store.state.profile.id && item.main_text != null" class="chat-container">
              <div class="chat-header">
                <img v-if="item.profile_image != null" :src="item.profile_image" alt="Avatar">
                <img v-else src="https://media.iamconnected.com/profile_images/default.png" alt="Avatar">
                <div class="chat-user-info">
                  <h5 class="user">{{item.first_name}} {{item.last_name}}</h5>
                  <span class="time">{{item.access.date}} {{item.access.time}}</span>
                </div>
                <div class="chat-actions">
                  <button @click="chatThreadModal(item)" title="Thread" class="btn thread threadBtn">
                    <b-badge v-if="item.replies > 0" class="threadBadge" variant="danger"> {{ item.replies }} </b-badge>
                    <i class="fas fa-solid fa-comment-dots fa-lg"></i>
                  </button>
                  <button v-if="$store.state.profile.level >= 90" @click="replyDelete(item, false)" class="btn delete"><i class="fas fa-trash-alt fa-lg red"></i></button>
                </div>
              </div>
              <p v-html="item.main_text" class="message"></p>
              <message-reactions :message="item" :activeChallengeId="activeChallengeId" @react="onReact" />
            </div>
          </b-list-group-item>
        </b-list-group>
        <b-form-textarea
          class="main-text"
          v-model="main_text"
          placeholder="Enter something..."
          rows="4"
          no-resize
        ></b-form-textarea>
        <strong>
          Program Chat
          <span v-if="members">({{members.length}} member{{ members.length === 1 ? '' : 's' }})</span>
        </strong>
        <b-button @click="replyAdd()" class="send-button" variant="primary">Send</b-button>
      </div>
    </div>

    <b-modal
      :id="'modal-chat-thread' + this.displayType"
      :title="modal.title"
      ok-title="Cancel"
      ok-only
      ok-variant="outline-primary"
      no-close-on-backdrop
    >

      <div class="wrapper">

        <div>
          <div class="empty-chat" v-if="!replies_thread || replies_thread.length === 0">
            <i class="fas fa-comments empty-chat__icon"></i>
            <p class="empty-chat__text">It's empty here</p>
            <p class="empty-chat__sub">Start a discussion!</p>
          </div>
          <div class="loadingThread text-center gold my-2" v-if="loadingThread">
            <b-spinner class="align-middle"></b-spinner>
            <br>
            <strong>Loading...</strong>
          </div>
          <div v-if="!loadingThread">
            <b-list-group
              v-for="item in replies_thread"
              :key="item.id"
              id="members_sharing"
              class="text-left mb-2">
              <b-list-group-item style="padding: 0px; border: 0px;">
                <div v-if="item.user_id === $store.state.profile.id && item.main_text != null" class="chat-container darker">
                  <div class="chat-header">
                    <img v-if="item.profile_image != null" :src="item.profile_image" alt="Avatar">
                    <img v-else src="https://media.iamconnected.com/profile_images/default.png" alt="Avatar">
                    <div class="chat-user-info">
                      <h5 class="user">{{item.first_name}} {{item.last_name}}</h5>
                      <span class="time">{{item.access.date}} {{item.access.time}}</span>
                    </div>
                    <div class="chat-actions">
                      <button @click="replyDelete(item, true)" class="btn delete"><i class="fas fa-trash-alt fa-lg"></i></button>
                    </div>
                  </div>
                  <p v-html="item.main_text" class="message"></p>
                </div>
                <div v-if="item.user_id !== $store.state.profile.id && item.main_text != null" class="chat-container">
                  <div class="chat-header">
                    <img v-if="item.profile_image != null" :src="item.profile_image" alt="Avatar">
                    <img v-else src="https://media.iamconnected.com/profile_images/default.png" alt="Avatar">
                    <div class="chat-user-info">
                      <h5 class="user">{{item.first_name}} {{item.last_name}}</h5>
                      <span class="time">{{item.access.date}} {{item.access.time}}</span>
                    </div>
                    <div class="chat-actions">
                      <button v-if="$store.state.profile.level >= 90" @click="replyDelete(item, true)" class="btn delete"><i class="fas fa-trash-alt fa-lg red"></i></button>
                    </div>
                  </div>
                  <p v-html="item.main_text" class="message"></p>
                </div>
              </b-list-group-item>
            </b-list-group>
          </div>
          <b-form-textarea
            class="main-text"
            v-model="main_text_thread"
            placeholder="Enter something..."
            rows="4"
            no-resize
          ></b-form-textarea>
          <strong>
            Program Chat
            <span v-if="members">({{members.length}} member{{ members.length === 1 ? '' : 's' }})</span>
          </strong>
          <b-button @click="chatThreadReply()" class="send-button" variant="primary">Send</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "@/axios";
import {strUtils} from '@/components/FormVaildation';
import MessageReactions from './MessageReactions.vue';

export default {
  name: 'ProgramChat',
  components: { MessageReactions },
  props: {
    activeChallengeId: {
      type: [String, Number],
      default: null,
    },
    challenge: {
      type: String,
      default: null,
    },
    // @todo tempo fix for double popup showing
    displayType: {
      type: String,
      default: null,
      required: true,
    },
    totalRows:Number,
    members: Array,
  },
  data() {
    return {
      errors: {},
      active_thread_item: null,
      main_text: null,
      main_text_thread: null,
      replies: [],
      replies_thread: [],
      challenge_members_email: [],
      loadingThread: false,
      modal: {
        title: '',
      },
    };
  },
  methods: {

    challengeMembersEmail() {
      let _this = this;
      _this.errors.join = '';
      _this.errors.join_class = '';
      _this.processing = 'Processing...';

      let params = new URLSearchParams();
      params.append('user_id', _this.$store.state.profile.id);
      params.append('challenge_title', _this.challenge);
      params.append('challenge_id', _this.activeChallengeId);

      for (const key in _this.members) {
        if (_this.members[key].id !== _this.$store.state.profile.id) {
          if (_this.members[key].program_notification?.val === '1') {
            _this.challenge_members_email.push(_this.members[key].id);
          }
        }
      }
      params.append('challenge_member_id', _this.challenge_members_email);

      axios({
        url: _this.$store.state.api_url + 'programChatEmail',
        params: params,
      })
        .then(function () {
          _this.errors.join = 'Email sent to program members!';
          _this.errors.join_class = 'text-success';
          _this.challenge_members_email = [];
          _this.processing = '';
        })
        .catch(function () {
          _this.processing = '';
          console.log('challengeMembersEmail: error');
        });
    },

    chatGet() {
      let _this = this;
      let params = new URLSearchParams();
      params.append('readonly', 0);

      params.append('user_id', this.$route.params.challenge_id);
      params.append('forum_id', this.$route.params.challenge_id);

      params.append('category', 'challenge_chat');

      params.append('limit', 50);
      params.append('order_by', 'access');
      params.append('order_direction', 'desc');
      params.append('type', 'edit');

      axios({
        url: `program/${this.$route.params.challenge_id}/chat`,
        params: params,
      })
        .then(function (response) {
          _this.replies = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    chatThreadModal(item) {
      this.modal.title = item.first_name + ' Thread';
      this.chatThreadCreate(item);
      this.$bvModal.show(`modal-chat-thread${this.displayType}`);
    },

    chatThreadCreate(item) {
      let _this = this;
      _this.loadingThread = true;
      let params = new URLSearchParams();
      params.append('title', item.title);
      params.append('first_name', item.first_name);
      params.append('last_name', item.last_name);
      params.append('user_id', item.user_id);
      params.append('id', item.id);
      params.append('main_text', item.main_text);

      axios({
        url: 'programChatThreadCreate',
        params: params,
      })
        .then(function (response) {
          if (response.data.status == 1) {
            _this.main_text_thread = '';
            _this.active_thread_item = response.data;
          }
          _this.main_text_thread = '';
          _this.chatThreadGet(_this.active_thread_item);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    chatThreadReply() {
      let _this = this;
      if(!strUtils.isEmpty(_this.main_text_thread)){

        _this.main_text_thread = this.replaceURLs(_this.main_text_thread);

        let params = new URLSearchParams();
        params.append('main_text', _this.main_text_thread);
        params.append('title', _this.main_text_thread);
        params.append('forum_id', _this.active_thread_item.meta.forum_id);

        params.append('user_id', _this.$store.state.profile.id);

        axios({
          url: 'programChatThreadReply',
          params: params,
        })
          .then(function (response) {
            if (response.data.status == 1) {
              _this.main_text_thread = '';
            }
            _this.main_text_thread = '';
            _this.chatThreadGet(_this.replies_thread);
          })
          .catch(function (error) {
            console.log(error);
          });
      }},

    chatThreadGet(item) {
      let _this = this;
      _this.loadingThread = true;

      console.log(item);

      let params = new URLSearchParams();

      params.append('forum_id', item.meta.forum_id);
      params.append('user_id', item.meta.user_id)

      params.append('category', 'challenge_chat_thread');

      params.append('limit', 50);
      params.append('order_by', 'access');
      params.append('order_direction', 'desc');
      params.append('type', 'edit');

      axios({
        url: 'programChatThreadGet',
        params: params,
      })
        .then(function (response) {
          _this.replies_thread = response.data;
          _this.active_thread_item = response.data;
          _this.loadingThread = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    replyAdd() {
      console.log('replyAdd');
      let _this = this;
      console.log(_this.main_text)
      if(!strUtils.isEmpty(_this.main_text)) {
        _this.main_text = this.replaceURLs(_this.main_text);

        const params = {}
        params['main_text'] = _this.main_text;
        params['title'] = _this.main_text;
        params['post_id'] = _this.activeChallengeId;
        params['view_user_id'] = _this.$store.state.profile.id;

        axios({
          method: 'post',
          url: `program/${_this.activeChallengeId}/reply`,
          data: params,
        })
          .then(function (response) {
            _this.main_text = '';
            _this.chatGet();
            _this.challengeMembersEmail();
            _this.main_text = '';
          })
          .catch(function (error) {
            console.log(error);
          });
      }},

    replyDelete(item, thread) {
      let _this = this;
      _this.main_text = this.replaceURLs(_this.main_text);
      let params = {};
      params['token'] = _this.$store.state.session_id;
      params['reply_id'] = item.id;
      params['reply'] = item;
      params['delete'] = 1;

      axios({
        method: 'post',
        url:  'programReplyDelete',
        data: params,
      })
        .then(function (response) {
          if (thread) _this.chatThreadGet(_this.active_thread_item);
          if (!thread) _this.chatGet();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    onReact({ messageId, reactionKey }) {
      const profile = this.$store.state.profile;
      const message = this.replies[messageId];
      if (!message) {
        return;
      }

      const reactions = message.reactions || [];
      const existingIndex = reactions.findIndex(r => r.user_id === profile.id);

      if (existingIndex >= 0 && reactions[existingIndex].reaction === reactionKey) {
        reactions.splice(existingIndex, 1);
      } else if (existingIndex >= 0) {
        reactions[existingIndex].reaction = reactionKey
      } else {
        reactions.push({
          id: Date.now(),
          reaction: reactionKey,
          user_id: profile.id,
          user: {
            full_name: profile.full_name || `${profile.first_name} ${profile.last_name}`,
            profile_image: profile.profile_image,
          },
        });
      }
      this.$set(message, 'reactions', reactions);
    },

    replaceURLs(text) {
      if(!text) return;

      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      return text.replace(urlRegex, function (url) {
        var hyperlink = url;
        if (!hyperlink.match('^https?:\/\/')) {
          hyperlink = 'http://' + hyperlink;
        }
        return '<a href="' + hyperlink + '" style="color:#d6b674;" target="_blank" rel="noopener noreferrer">' + url + '</a>'
      });
    },
  },
  mounted() {
    this.chatGet();
  },
};
</script>

<style scoped>
/* Chat containers */
.chat-container {
  border: 2px solid #dedede;
  background-color: #f1f1f1;
  border-radius: 20px;
  padding: 10px;
  margin: 5px 0;
  position: relative;
}

/* Darker chat container */
.darker {
  border-color: #ccc;
  background-color: #ddd;
}

/* Clear floats */
.chat-container::after {
  content: "";
  clear: both;
  display: table;
}

.chat-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

/* Style images */
.chat-header img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  flex-shrink: 0;
}

.chat-user-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.chat-actions {
  display: flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;
}

/* Style time text */
.time {
  color: #999;
  font-size: 0.78rem;
  margin: 0;
}

.message {
  margin: 0;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.thread {
  color: #d6b674;
  border: none;
  padding: 6px;
  display: flex;
}

.threadBadge {
  border-radius: 30%;
  margin-right: 5px;
}

.delete {
  color: red;
  border: none;
  padding: 6px;
  display: flex;
}

.user {
  margin: 0;
  font-size: 0.9rem;
}

.wrapper {
  margin: 0 auto;
  max-width: 100%;
  max-height: 500px;
  min-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column-reverse;
  padding-right: 2%;
  padding-left: 2%;
}

.main-text {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  margin-bottom: 5px;
}

.send-button {
  margin: 0px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  padding: 5px 16px;
  margin-bottom: 5px;
  float: right;
}

.a:link {
  color: #d6b674;
}

.empty-chat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 8px;
}

.empty-chat__icon {
  font-size: 2.5rem;
  color: #d6b674;
  opacity: 0.6;
  margin-bottom: 6px;
}

.empty-chat__text {
  font-size: 1rem;
  font-weight: 600;
  color: #555;
  margin: 0;
}

.empty-chat__sub {
  font-size: 0.82rem;
  color: #aaa;
  margin: 0;
}

.loadingThread {
  padding-bottom: 250px;
}
</style>
